














































































import Vue from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/account';
import { TableItem, TableList } from '@/class/models/typed/customer-mail';


export default Vue.extend({
  name: 'Invoice',
  data() {
    return {
      data: {} as models.VInvoice,
      tableList: new TableList(),
      groupedTableList: [] as Array<{ key: string, items: TableItem[]}>,
    };
  },
  computed: {
    NOTIFICATION() {
      return NOC.NOTIFICATION;
    },
  },
  mounted() {
    const storage = localStorage.getItem('/Invoice');
    if (storage) {
      this.data = JSON.parse(storage) as models.VInvoice;
      this.tableList.insertInvoiceData(this.data);
      this.groupedTableList = this.tableList.groupAndSortByDateDescending();

      localStorage.removeItem('/Invoice');
      // 印刷用グローバルCSSを他の画面に影響しないように、ここだけはhtmlタグにクラス名追加
      document.documentElement.classList.add('html-invoice-mail');
    } else {
      window.close();
      this.$router.replace('/');
    }
  },
});
